import { useQuery } from '@tanstack/react-query';

const fetchLatestPodcastEpisode = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/podcast/episodes`);
  
  if (!response.ok) {
    throw new Error('Failed to fetch podcast episodes');
  }
  
  const data = await response.json();
  
  // Return the first episode (latest) if available
  if (data.episodes && data.episodes.length > 0) {
    return data.episodes[0];
  }
  
  return null;
};

export const useLatestPodcastEpisode = () => {
  return useQuery({
    queryKey: ['latestPodcastEpisode'],
    queryFn: fetchLatestPodcastEpisode,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
    refetchOnWindowFocus: false
  });
};

